import React from 'react';
import { createRoot } from 'react-dom/client';
import Routes from './route';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/importAll.scss';
import '../node_modules/@youseedk/dna/ys-bundle.min.css';
import { ContextWrapper } from './stateManager';
import ScrollToTop from './modules/scrollToTop';
import { Navigation, Footer } from '@nuuday/ys-navigation';

const App = () => {
  return (
    <main className="App">
      <Navigation hideBasketIcon env={process.env.NODE_ENV === 'production' ? 'prod' : 'test'} />
      <Router>
        <ScrollToTop>
          <Routes />
        </ScrollToTop>
      </Router>
      <Footer />
    </main>
  );
};

const rootElement = document.getElementById('main');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <ContextWrapper>
      <App />
    </ContextWrapper>
  );
}
